/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to explicitly set the size of the widget.
 * By default the widget is auto-sized to fit its contents.
 * If the user wants to explicitly size the widget then they can set the "width" and "height"  property,
 * Content will be clipped if it does not fit in the specified width and height.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * <em>Attach-point:</em> domNode<br>
 * Sizing behaviors vary for widgets with different templates.
 * The toolstrip implementation overrides the height adjustments.
 *
 * @module MW/toolstrip/mixins/property/SizeMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {

    return declare(null, {
        postCreate: function () {
            this.inherited(arguments);
            this.width = "auto";
            this.height = "auto";
        },

        _setHeightAttr: function (height) {
            // User cannot set size on toolstrip
        },

        _getHeightAttr: function () {
            // User cannot set size on toolstrip
            if (this.get("orientation") === "Horizontal") {
                return 22;
            } else {
                return 72;
            }
        }
    });
});
